import { render, staticRenderFns } from "./PosPrinterHub.vue?vue&type=template&id=8a0712fc"
import script from "./PosPrinterHub.vue?vue&type=script&lang=js"
export * from "./PosPrinterHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports